import SearchProduct from './SearchProduct';
import './_SearchProduct.scss';

export {SearchProduct};



// WEBPACK FOOTER //
// ./components/search-product/index.js